$(document).ready(function() {

    if ($(".g-updates").length > 0) {

        $('.g-update__header').click(function() {

            // if current has class open
            if ($(this).hasClass('g-update__header--open')) {
                // remove class
                $(this).removeClass('g-update__header--open');
            } else {
                // else add class and remove from others
                $('.g-update__header').removeClass('g-update__header--open');
                $(this).addClass('g-update__header--open');
            }   

            $('.g-update__content').slideUp();
            
            if ($(this).next('.g-update__content').is(':visible')) {
                $(this).next('.g-update__content').slideUp();
                return;
            } else {
                $(this).next('.g-update__content').slideDown();
            }
            
        });
    }

});